import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DebugService {
    /**
     * Get Plan Id From Job Id
     * Get the plan id associated to a given job id.
     * @param jobId The job ID to fetch the plan ID for
     * @param jobVersion The job version to fetch the plan ID for
     * @returns any Successful Response
     * @throws ApiError
     */
    static getPlanIdFromJobId(jobId, jobVersion) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/debug/plan_id_from_job_id',
            query: {
                'job_id': jobId,
                'job_version': jobVersion,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Job From Plan Id
     * Get the job associated to a given plan id.
     * @param planId The plan ID to fetch the job for
     * @returns any Successful Response
     * @throws ApiError
     */
    static getJobFromPlanId(planId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/debug/job_from_plan_id',
            query: {
                'plan_id': planId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Code Deploy Page
     * Provide the code deploy page.
     * @returns string Successful Response
     * @throws ApiError
     */
    static codeDeployPage() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/debug/spawn-deployment',
        });
    }
    /**
     * Get Planner Backend Config
     * Get backend plan configuration.
     * @returns BackendPlanConfigStorage Successful Response
     * @throws ApiError
     */
    static getPlannerBackendConfig() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/debug/plan/config',
        });
    }
    /**
     * Change Planner Backend Config
     * Modify backend plan configuration.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static changePlannerBackendConfig(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/debug/plan/config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete All Plans
     * Delete all plans from the db.
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteAllPlans() {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/debug/plan/',
        });
    }
    /**
     * Get Plans
     * Retrieve a list of lite plans from the database.
     * @returns PlanLite Successful Response
     * @throws ApiError
     */
    static getPlans() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/debug/plan',
        });
    }
    /**
     * Delete Plan
     * Delete the plan for the given id.
     * @param planId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deletePlan(planId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/debug/plan/{plan_id}',
            path: {
                'plan_id': planId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Expanded Plan
     * Get the expanded plan data for the provided plan ID.
     * @param planId
     * @param segment
     * @returns PlanDataSegment Successful Response
     * @throws ApiError
     */
    static getExpandedPlan(planId, segment) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/debug/plan/expanded/{plan_id}',
            path: {
                'plan_id': planId,
            },
            query: {
                'segment': segment,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
